import { Component, OnInit } from '@angular/core';
import * as globals from '../../../settings';

@Component({
  selector: 'app-icon-container',
  templateUrl: './icon-container.component.html',
  styleUrls: ['./icon-container.component.scss', './icon-container.mobile.component.scss']
})
export class IconContainerComponent implements OnInit {
  brand = globals.brand;
  constructor() { }

  ngOnInit() {
  }

}
